import { Route, Switch } from 'react-router-dom';
import { routes } from 'components/routes';
import { ProtectedRoute } from 'components/routes/ProtectedRoute';

export const Routers = () => {
	return (
		<Switch>
			{routes.map((route, index) => {
				return route.protected ? (
					<ProtectedRoute key={index} {...route} />
				) : (
					<Route key={index} {...route} />
				);
			})}
		</Switch>
	);
};
